$(window).on('resize', function() {
  let width = $(window).width();
  if (width > 1201) {
    $(".nav-main").fadeIn();
    $(".hamburger").removeClass('active');
  } else {
    $(".nav-main").fadeOut();
  }
});

$(".hamburger").on("click", function (e) {
  e.stopPropagation();
  if($(".hamburger").hasClass('active')){
    $(".nav-main").fadeOut();
    $(".hamburger").removeClass('active');
  } else {
    $(".nav-main").fadeIn();
    $(".hamburger").addClass('active');
  }
});

$(document).on("click", function (e) {
  const width = $(window).width();
  if (width < 1201 && !$(e.target).closest("nav").length) {
    $(".nav-main").fadeOut();
    $(".hamburger").removeClass('active');
  }
});

$(".btn-settings").on("click", function (e) {
  $(".nav-main").fadeOut();
});
